import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export interface ICommonModal {
  title: string;
  open: boolean;
  handleClose?(): void;
  FooterComponent?: React.ReactNode;
  hideCloseButton?: boolean;
}

const CommonModal: React.FC<ICommonModal> = (props) => {
  const {
    open,
    title,
    handleClose,
    FooterComponent,
    children,
    hideCloseButton,
  } = props;

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "30%",
          bgcolor: "white",
          boxShadow: "6px rgb(0 0 0 / 4%)",
          borderRadius: 2,
          p: "20px",
          overflowY: "auto",
          maxHeight: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h2">{title}</Typography>
          {!hideCloseButton && (
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>

        <Box sx={{ mt: 2, mb: 2 }}>{children}</Box>
        {FooterComponent}
      </Box>
    </Modal>
  );
};

export default CommonModal;
